import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ManageCorporateService } from './manage-corporate.service';
import { CommonService } from '../../shared/services/common/common.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

interface ApiResponse {
  statusCode: number;
  data: {
    response: any[];
  };
}

@Component({
  selector: 'app-manage-corporate',
  templateUrl: './manage-corporate.component.html',
  styleUrls: ['./manage-corporate.component.scss'],
  imports: [CommonModule, SharedModule],
})
export class ManageCorporateComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['serialNo', 'companyID', 'name', 'email', 'phone', 'role', 'action'];
  corporateDataSource: MatTableDataSource<any>;
  isLoading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private corporateService: ManageCorporateService,
    private commonService: CommonService
  ) {
    this.corporateDataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.loadCorporateList();
  }

  ngAfterViewInit() {
    this.corporateDataSource.paginator = this.paginator;
    this.corporateDataSource.sort = this.sort;
  }

  loadCorporateList(): void {
    this.isLoading = true;
    const userData = this.commonService.getUserDetails();

    const loginID = userData.userId;
    const userType = userData.userType;
    const role = userData.userRole;

    this.corporateService.getCorporateEmployees(loginID, userType, role).subscribe({
      next: (response: ApiResponse) => {
        if (response && response.statusCode === 200) {
          this.corporateDataSource.data = response.data.response;
          this.isLoading = false;
        } else {
          console.error('API Error:', response);
          this.isLoading = false;
        }
      },
      error: (error: Error) => {
        console.error('API Error:', error);
        this.isLoading = false;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.corporateDataSource.filter = filterValue.trim().toLowerCase();

    if (this.corporateDataSource.paginator) {
      this.corporateDataSource.paginator.firstPage();
    }
  }

  clearSearch(input: HTMLInputElement) {
    input.value = '';
    this.corporateDataSource.filter = '';
    if (this.corporateDataSource.paginator) {
      this.corporateDataSource.paginator.firstPage();
    }
  }

  editCorporate(corp: any): void {
    // Add actual edit implementation here
  }

  deleteCorporate(id: number): void {
    // if (confirm('Are you sure you want to delete this corporate employee?')) {
    //   this.corporateService.deleteCorporate(id).subscribe({
    //     next: (response) => {
    //       if (response && response.statusCode === 200) {
    //         // Refresh the list after successful deletion
    //         this.loadCorporateEmployees();
    //       }
    //     },
    //     error: (error) => {
    //       console.error('Error deleting corporate employee:', error);
    //     }
    //   });
    // }
  }
}